/** @format */

import { Helmet } from "fusion-plugin-react-helmet-async";
import QuoteStep from "../enums/QuoteStep";
import useQuoteStore from "../store/QuoteStore";
import useAppStateStore from "../../../shared/store/AppStateStore";
import { handleNext } from "../../../shared/utils/navigationUtils";
import { assetUrl } from "fusion-core";
import ModalWrapper from "../../../shared/components/ModalWrapper";
import ModalActionButtons from "../../../shared/components/ModalActionButtons";

const UberDetailsConfirmationModal = ({ onClose }) => {
  const STATE = useAppStateStore();
  const css = assetUrl("../../../styles/confirmationModal.css");
  const { updateField } = useQuoteStore.getState();
  const quoteStore = useQuoteStore.getState();
  const driver = quoteStore?.quote?.risk?.drivers[0];
  const vehicles = quoteStore?.quote?.risk?.vehicles;
  const isValidVehicleOnNewQuote = STATE.isValidVehicleOnNewQuote;
  const isValidAddressOnNewQuote = STATE.isValidAddressOnNewQuote;

  const handleYesClick = () => {
    STATE.setHideTq2Questions(true);
    updateField("risk.drivers.0.datePassedTest", "2008-01-01T00:00:00");
    if (!isValidVehicleOnNewQuote || !isValidAddressOnNewQuote) {
      handleNext(QuoteStep.TQ1, STATE);
    } else if (driver.address) {
      handleNext(QuoteStep.TQ3, STATE);
    } else {
      handleNext(QuoteStep.TQ2, STATE);
    }
    STATE.setQuoteCall(true);
    onClose();
  };

  const handleEditClick = () => {
    if (!isValidVehicleOnNewQuote || !isValidAddressOnNewQuote) {
      handleNext(QuoteStep.TQ1, STATE);
    }
    STATE.setHideTq2Questions(false);
    updateField("risk.drivers.0.datePassedTest", null);
    STATE.setQuoteCall(true);
    onClose();
  };

  return (
    <>
      <Helmet>
        <link rel="stylesheet" href={css} />
      </Helmet>
      {driver.forename && (
        <ModalWrapper
          heading="Your Information"
          onClose={() => setModalOpen(false)}
          showClose={false}
        >
          <div>
            <table className="confirmation-details-content">
              <tbody>
                {[
                  {
                    label: "Name",
                    value: `${driver.forename} ${driver.surname}`,
                  },
                  { label: "Email", value: driver.emailAddress },
                  { label: "Telephone", value: driver.telephone },
                  {
                    label: "Date of birth",
                    value: driver.dateOfBirth
                      .split("T")[0]
                      .split("-")
                      .reverse()
                      .join("/"),
                  },
                  {
                    label: "Licence number",
                    value: driver.licenceNumber
                      ? `${driver.licenceNumber.slice(
                          0,
                          11
                        )} - ${driver.licenceNumber.slice(11)}`
                      : "",
                  },
                  driver.address && {
                    label: "Home address",
                    value: `${driver.address.houseNo || ""}, ${driver.address
                      .street || ""}, ${driver.address.city || ""}, ${driver
                      .address.postcode || ""}`,
                  },
                  {
                    label: "Uber Pro rating",
                    value: driver.uberDriverRatingId,
                  },
                  {
                    label: "Registration number",
                    value: vehicles[0]?.licensingPlateNumber,
                  },
                  {
                    label: "Occupation",
                    value:
                      driver.occupations?.[0]?.occupationDescription ||
                      "Uber Driver",
                  },
                  {
                    label: "Business",
                    value: "Taxi Service",
                  },
                  {
                    label: "Employee status",
                    value: "Self Employed",
                  },
                ]
                  .filter(Boolean)
                  .map((item, index) => (
                    <tr key={index}>
                      <td className="confirmation-details-label">
                        <strong>{item.label}</strong>
                      </td>
                      <td className="confirmation-details-value">
                        {item.value}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <ModalActionButtons
              label="Is this information correct?"
              primaryText="Yes"
              secondaryText="Edit"
              onPrimaryClick={handleYesClick}
              onSecondaryClick={handleEditClick}
            />
          </div>
        </ModalWrapper>
      )}
    </>
  );
};

export default UberDetailsConfirmationModal;
